import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import api from "../config/axios";

function Messages() {
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingMessage, setEditingMessage] = useState(null);
  const [formData, setFormData] = useState({
    command: "",
    message: "",
    category: "general",
    is_auto: false,
    order_index: 0,
  });

  const categories = [
    { value: "general", label: "Général" },
    { value: "invite", label: "Invité" },
    { value: "special", label: "Spécial" },
    { value: "chroniqueur", label: "Chroniqueur" },
  ];

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await api.get("/api/messages");
      setMessages(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des messages:", error);
    }
  };

  const handleOpen = (message = null) => {
    if (message) {
      setEditingMessage(message);
      setFormData({
        command: message.command,
        message: message.message,
        category: message.category,
        is_auto: message.is_auto || false,
        order_index: message.order_index || 0,
      });
    } else {
      setEditingMessage(null);
      setFormData({
        command: "",
        message: "",
        category: "general",
        is_auto: false,
        order_index: 0,
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditingMessage(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validation : seuls les messages 'general' peuvent être automatiques
      const dataToSend = {
        ...formData,
        is_auto: formData.category === "general" ? formData.is_auto : false,
        order_index: formData.category === "general" ? formData.order_index : 0,
      };

      if (editingMessage) {
        await api.put(`/api/messages/${editingMessage.id}`, dataToSend);
      } else {
        await api.post("/api/messages", dataToSend);
      }
      fetchMessages();
      handleClose();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde du message:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce message ?")) {
      try {
        await api.delete(`/api/messages/${id}`);
        fetchMessages();
      } catch (error) {
        console.error("Erreur lors de la suppression du message:", error);
      }
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h4">Messages</Typography>
        <Button variant="contained" onClick={() => handleOpen()}>
          Nouveau message
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Commande</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Catégorie</TableCell>
              <TableCell>Auto</TableCell>
              <TableCell>Ordre</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messages.map((message) => (
              <TableRow key={message.id}>
                <TableCell>!{message.command}</TableCell>
                <TableCell>{message.message}</TableCell>
                <TableCell>{message.category}</TableCell>
                <TableCell>{message.is_auto === 1 ? "Oui" : "Non"}</TableCell>
                <TableCell>{message.order_index || "-"}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpen(message)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(message.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editingMessage ? "Modifier le message" : "Nouveau message"}
        </DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Commande"
              value={formData.command}
              onChange={(e) =>
                setFormData({ ...formData, command: e.target.value })
              }
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Message"
              value={formData.message}
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
              margin="normal"
              required
              multiline
              rows={4}
            />
            <TextField
              fullWidth
              select
              label="Catégorie"
              value={formData.category}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  category: e.target.value,
                });
              }}
              margin="normal"
              required
            >
              {categories.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_auto}
                  onChange={(e) =>
                    setFormData({ ...formData, is_auto: e.target.checked })
                  }
                />
              }
              label="Message automatique"
            />
            {formData.is_auto && (
              <TextField
                fullWidth
                type="number"
                label="Ordre d'affichage"
                value={formData.order_index}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    order_index: parseInt(e.target.value) || 0,
                  })
                }
                margin="normal"
              />
            )}
            <DialogActions>
              <Button onClick={handleClose}>Annuler</Button>
              <Button type="submit" variant="contained">
                {editingMessage ? "Modifier" : "Créer"}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Messages;
